import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import { Watch } from "react-loader-spinner";
import Select from "react-select";
import DatePicker from "react-date-picker";
import axios from "axios";
import moment from "moment/moment";

const initialValue = {
  id: null,
  user_id: null,
  payment_type: "Received",
  payment_mode: "BANK",
  remark: "",
  amount: "",
  date: new Date(),
};

const pTypeDrp = [
  { value: "Received", label: "Received" },
  { value: "Paid", label: "For Invoice" },
];

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddPayment = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const [isError, setError] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [formValue, setFormValue] = useState(initialValue);
  const [partyDrp, setPartyDrp] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPartyData = () => {
    axios.post(API_URL.PARTY_LIST, {}).then((res) => {
      if (res?.data?.data?.length > 0) {
        let pt = res.data.data.map((raw) => {
          return {
            label: raw.name,
            value: raw.id,
          };
        });
        setPartyDrp(pt);
      }
    });
  };

  const onEdit = () => {
    axios.post(API_URL.PAYMENT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          user_id: res.data.data.user_id,
          date: moment(res.data.data.date, "YYYY-MM-DD").toDate(),
          remark: res.data.data.remark,
          amount: res.data.data.amount,
          payment_mode: res.data.data.payment_mode,
          payment_type: res.data.data.payment_type
        });
      }
    });
  };

  const onSave = () => {
    setSubmitting(true);
    setError(false);
    setLoading(true);
    if (formValue.user_id && formValue.amount && formValue.date) {
      const url = id ? API_URL.PAYMENT_UPDATE : API_URL.PAYMENT_SAVE;
      let body = {
        amount: formValue.amount,
        user_id: formValue.user_id,
        date: moment(formValue.date).format("YYYY-MM-DD"),
        remark: formValue.remark,
        payment_mode: formValue.payment_mode,
        payment_type: formValue.payment_type
      };
      if (id) {
        body["id"] = id;
      }
      axios.post(url, body).then((res) => {
        if (res.data.status === 1) {
          let message = id
            ? "Payment Updated Successfully."
            : "payment Created Successfully.";
          toast.success(message, { autoClose: 3000, position: "top-right" });
          setLoading(false);
          navigate("/admin/payment");
        } else {
          setLoading(false);
          setError(true);
        }
        setSubmitting(false);
      });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const setFormData = (name, value) => {
    setFormValue({ ...formValue, [name]: value });
  };
  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  useEffect(() => {
    getPartyData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Payment</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form onSubmit={(event) => event.preventDefault()}>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="payment_type">
                    Type<span className="required-star">*</span>
                  </label>
                  <div
                    className={`${isError && !formValue.payment_type && "error1"}`}
                  >
                    <Select
                      id="payment_type"
                      name="payment_type"
                      placeholder=""
                      options={pTypeDrp}
                      value={
                        pTypeDrp.find((d) => d.value == formValue.payment_type) ||
                        null
                      }
                      styles={
                        isRequiredField("payment_type")
                          ? customRequireStyles
                          : customStyles
                      } onChange={(e) => setFormData("payment_type", e.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="user_id">
                    Party<span className="required-star">*</span>
                  </label>
                  <div
                    className={`${isError && !formValue.user_id && "error1"
                      }`}
                  >
                    <Select
                      id="user_id"
                      name="user_id"
                      placeholder=""
                      options={partyDrp}
                      value={
                        partyDrp.find(
                          (d) => d.value === formValue.user_id
                        ) || null
                      }
                      styles={
                        isRequiredField("user_id")
                          ? customRequireStyles
                          : customStyles
                      } onChange={(e) => setFormData("user_id", e.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="date">Date<span className="required-star">*</span></label>
                  <DatePicker
                    id="date"
                    name="date"
                    placeholder=""
                    showIcon={true}
                    onKeyDown={(e) => {
                      e.preventDefault();
                    }}
                    dateFormat={"dd/MM/yyyy"}
                    clearIcon={false}
                    className={
                      isRequiredField("date")
                        ? "form-control required"
                        : "form-control"
                    } onChange={(e) => {
                      setFormData("date", e);
                    }}
                    selected={formValue.date}
                    value={formValue.date}

                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="amount">
                    Amount.<span className="required-star">*</span>
                  </label>
                  <input
                    id="amount"
                    name="amount"
                    type="number"
                    value={formValue.amount}
                    onChange={(e) => setFormData("amount", e.target.value)}
                    className={
                      isRequiredField("amount")
                        ? "form-control required"
                        : "form-control"
                    }
                    placeholder=""
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor="remark">
                    Remark<span className="required-star">*</span>
                  </label>
                  <textarea
                    id="remark"
                    name="remark"
                    type="text"
                    value={formValue.remark}
                    onChange={(e) => setFormData("remark", e.target.value)}
                    className={
                      isRequiredField("remark")
                        ? "form-control required"
                        : "form-control"
                    }
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3 mb-3">
              <div className="col-md-8">
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                <div className="text-end">
                  <Link
                    to={"/admin/payment"}
                    className={
                      loading
                        ? "btn btn-danger btn-sm me-2 disabled-link"
                        : "btn btn-danger btn-sm me-2"
                    }
                    onClick={(e) => loading && e.preventDefault()}
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={onSave}
                    disabled={loading}
                    className="btn btn-primary btn-sm"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {loading && (
                        <Watch color={"white"} height={15} width={15} />
                      )}
                      Submit
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddPayment;
